/**
 * collection-page.js
 * Handles: swatches, AJAX add-to-cart, wishlist, filter auto-submit, mobile sidebar
 */

(function () {
  'use strict';

  /* ── Helpers ────────────────────────────────────────────── */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }

  /* ── Wishlist (localStorage) ─────────────────────────────── */
  var WISH_KEY = 'glam42_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }

  function isWished(productId) {
    return getWishlist().indexOf(String(productId)) !== -1;
  }

  function toggleWish(productId) {
    var list = getWishlist();
    var id = String(productId);
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return idx === -1; // returns true if now wished
  }

  function syncWishButtons() {
    qsa('.js-pcard-wishlist').forEach(function (btn) {
      var id = btn.dataset.productId;
      if (isWished(id)) {
        btn.classList.add('is-wished');
        btn.setAttribute('aria-label', 'הסר ממועדפים');
      } else {
        btn.classList.remove('is-wished');
        btn.setAttribute('aria-label', 'הוסף למועדפים');
      }
    });
  }

  /* ── AJAX Add to Cart ─────────────────────────────────────── */
  function addToCart(variantId, btn) {
    if (!variantId || btn.disabled) return;

    var textEl = qs('.pcard__atc-text', btn);
    var loadEl = qs('.pcard__atc-loading', btn);

    btn.classList.add('is-loading');
    btn.disabled = true;
    if (textEl) textEl.hidden = true;
    if (loadEl) loadEl.removeAttribute('hidden');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.description) {
        // Error returned by Shopify
        showCartFeedback(btn, 'error', data.description);
        return;
      }
      // Success
      showCartFeedback(btn, 'success', '✓ נוסף לסל');

      // Update cart count bubbles if present
      updateCartCount();

      // Trigger custom event for any mini-cart integration
      document.dispatchEvent(new CustomEvent('cart:added', { detail: data }));

      // Open cart drawer / modal
      var cartConfig = document.getElementById('cart-config');
      if (cartConfig) {
        try {
          var cfg = JSON.parse(cartConfig.innerHTML || '{}');
          if (Shopify && Shopify.theme && Shopify.theme.ajaxCart) {
            Shopify.theme.ajaxCart.updateView(cfg, data);
            if (cfg.cart_action === 'drawer') {
              Shopify.theme.ajaxCart.showDrawer(cfg);
            } else if (cfg.cart_action === 'modal_cart') {
              Shopify.theme.ajaxCart.showModal(cfg);
            }
          }
        } catch(e) {}
      }
    })
    .catch(function () {
      showCartFeedback(btn, 'error', 'שגיאה');
    })
    .finally(function () {
      btn.classList.remove('is-loading');
      if (textEl) textEl.removeAttribute('hidden');
      if (loadEl) loadEl.hidden = true;
    });
  }

  function showCartFeedback(btn, type, msg) {
    var textEl = qs('.pcard__atc-text', btn);
    var originalText = textEl ? textEl.textContent : '';

    if (type === 'success') {
      btn.classList.add('pcard__atc--added');
    }

    if (textEl) textEl.textContent = msg;
    btn.disabled = false;

    setTimeout(function () {
      btn.classList.remove('pcard__atc--added');
      if (textEl) textEl.textContent = originalText;
    }, 2000);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = Number(cart && cart.item_count);
        if (!Number.isFinite(count) || count < 0) count = 0;

        qsa('[data-cart-count], .cart-count, .js-cart-count, #CartCount').forEach(function (el) {
          el.textContent = String(count);
          if (count === 0) {
            el.classList.add('hide');
          } else {
            el.classList.remove('hide');
          }
        });
      })
      .catch(function () {});
  }

  /* ── Size variant buttons ─────────────────────────────────── */
  function initSizes(card) {
    var sizeList = qs('.js-pcard-sizes', card);
    if (!sizeList) return;

    var sizeOptionIndex = parseInt(sizeList.dataset.optionIndex, 10);
    var sizeBtns = qsa('.pcard__size-btn', sizeList);
    var sizeViewport = sizeList.parentElement; // .pcard__sizes-viewport
    var prevBtn = qs('.pcard__sizes-arrow--prev', card);
    var nextBtn = qs('.pcard__sizes-arrow--next', card);
    var STEP = 120;

    // On mobile: remove arrows entirely (just free scroll)
    var isMobile = window.matchMedia('(max-width: 640px)').matches;
    if (isMobile) {
      if (prevBtn && prevBtn.parentNode) prevBtn.parentNode.removeChild(prevBtn);
      if (nextBtn && nextBtn.parentNode) nextBtn.parentNode.removeChild(nextBtn);
      prevBtn = null;
      nextBtn = null;
    }

    function updateSizeArrows() {
      if (isMobile || !prevBtn || !nextBtn) return;
      var needsScroll = sizeViewport.scrollWidth > sizeViewport.clientWidth + 2;
      if (!needsScroll) {
        prevBtn.style.setProperty('display', 'none', 'important');
        nextBtn.style.setProperty('display', 'none', 'important');
      } else {
        prevBtn.style.removeProperty('display');
        nextBtn.style.removeProperty('display');
        // RTL: scrollLeft is 0 at rightmost, negative when scrolled left
        var atStart = Math.abs(sizeViewport.scrollLeft) <= 1;
        var atEnd = Math.abs(sizeViewport.scrollLeft) + sizeViewport.clientWidth >= sizeViewport.scrollWidth - 1;
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
      }
    }

    setTimeout(updateSizeArrows, 50);
    on(sizeViewport, 'scroll', updateSizeArrows);

    if (prevBtn) {
      on(prevBtn, 'click', function () {
        sizeViewport.scrollBy({ left: STEP, behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      on(nextBtn, 'click', function () {
        sizeViewport.scrollBy({ left: -STEP, behavior: 'smooth' });
      });
    }

    // Parse variant data embedded in the card
    var variants = [];
    var scriptEl = qs('[data-pcard-variants]', card);
    if (scriptEl) {
      try { variants = JSON.parse(scriptEl.textContent); } catch (e) {}
    }

    function findVariantForSize(sizeValue) {
      if (!variants.length) return null;
      var currentId = parseInt(card.dataset.variantId, 10);
      var currentVariant = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === currentId) { currentVariant = variants[i]; break; }
      }
      // Find variant matching all current options except replacing size option
      var match = null;
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        var ok = true;
        for (var k = 0; k < v.options.length; k++) {
          if (k === sizeOptionIndex) {
            if (v.options[k] !== sizeValue) { ok = false; break; }
          } else if (currentVariant) {
            if (v.options[k] !== currentVariant.options[k]) { ok = false; break; }
          }
        }
        if (ok) { match = v; break; }
      }
      // Fallback: first variant with this size
      if (!match) {
        for (var m = 0; m < variants.length; m++) {
          if (variants[m].options[sizeOptionIndex] === sizeValue) { match = variants[m]; break; }
        }
      }
      return match;
    }

    function applyPriceFromBtn(btn) {
      var priceRow = qs('.pcard__price-row', card);
      if (!priceRow || !btn) return;
      var price = btn.dataset.price || '';
      var compare = btn.dataset.comparePrice || '';
      var hasSale = btn.dataset.hasSale === 'true';
      if (hasSale && compare) {
        priceRow.innerHTML =
          '<span class="pcard__price pcard__price--sale">' + price + '</span>' +
          '<s class="pcard__price pcard__price--was">' + compare + '</s>';
      } else {
        priceRow.innerHTML = '<span class="pcard__price pcard__price--regular">' + price + '</span>';
      }
    }

    sizeBtns.forEach(function (btn) {
      on(btn, 'click', function () {
        sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        var sizeValue = btn.dataset.sizeValue;
        var variant = findVariantForSize(sizeValue);

        if (variant) {
          card.dataset.variantId = variant.id;
          var atcBtn = qs('.js-pcard-atc', card);
          if (atcBtn) atcBtn.dataset.variantId = variant.id;
        }

        applyPriceFromBtn(btn);
      });
    });
  }

  /* ── Swatch interaction ───────────────────────────────────── */
  function initSwatches(card) {
    var swatchList = qs('.js-pcard-swatches', card);
    if (!swatchList) return;

    var viewport = swatchList.parentElement; // .pcard__swatches-viewport
    var swatches = qsa('.pcard__swatch', swatchList);
    var mainImg = qs('[data-pcard-main-img]', card);
    var prevBtn = qs('.pcard__swatches-arrow--prev', card);
    var nextBtn = qs('.pcard__swatches-arrow--next', card);
    var SWATCH_SIZE = 38; // 28px swatch + 10px gap
    var STEP = SWATCH_SIZE * 3;
    var MAX_VISIBLE = 7;
    var wrap = qs('.pcard__swatches-wrap', card);

    // On mobile, permanently hide arrows
    var isMobile = window.matchMedia('(max-width: 640px)').matches;
    if (isMobile) {
      // Remove arrows from DOM entirely so nothing can re-show them
      if (prevBtn && prevBtn.parentNode) prevBtn.parentNode.removeChild(prevBtn);
      if (nextBtn && nextBtn.parentNode) nextBtn.parentNode.removeChild(nextBtn);
      prevBtn = null;
      nextBtn = null;
      if (wrap) wrap.style.justifyContent = 'flex-start';
    }

    // If 7 or fewer swatches, center them and hide arrows
    if (swatches.length <= MAX_VISIBLE) {
      if (prevBtn) prevBtn.style.setProperty('display', 'none', 'important');
      if (nextBtn) nextBtn.style.setProperty('display', 'none', 'important');
      // swatches stay right-aligned (RTL default), no centering
    }

    function updateArrows() {
      if (isMobile) return;
      if (!prevBtn || !nextBtn) return;
      if (swatches.length <= MAX_VISIBLE) return;
      var needsScroll = viewport.scrollWidth > viewport.clientWidth + 2;
      if (!needsScroll) {
        prevBtn.style.setProperty('display', 'none', 'important');
        nextBtn.style.setProperty('display', 'none', 'important');
      } else {
        prevBtn.style.removeProperty('display');
        nextBtn.style.removeProperty('display');
        // RTL: scrollLeft is 0 at start (right), negative when scrolled left
        var atStart = Math.abs(viewport.scrollLeft) <= 1;
        var atEnd = Math.abs(viewport.scrollLeft) + viewport.clientWidth >= viewport.scrollWidth - 1;
        prevBtn.disabled = atStart;  // prev goes right (back to start)
        nextBtn.disabled = atEnd;     // next goes left (to end)
      }
    }

    // Initial check after layout
    setTimeout(updateArrows, 50);
    on(viewport, 'scroll', updateArrows);

    if (prevBtn) {
      on(prevBtn, 'click', function () {
        // RTL: prev goes right (positive direction)
        viewport.scrollBy({ left: STEP, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      on(nextBtn, 'click', function () {
        // RTL: next goes left (negative direction)
        viewport.scrollBy({ left: -STEP, behavior: 'smooth' });
      });
    }

    swatches.forEach(function (swatch) {
      var colorNameEl = qs('.js-pcard-color-name', card);

      on(swatch, 'mouseover', function () {
        if (colorNameEl) colorNameEl.textContent = swatch.dataset.value || '';
      });

      on(swatch, 'mouseout', function () {
        if (colorNameEl) {
          var activeSwatch = qs('.pcard__swatch.is-active', swatchList);
          colorNameEl.textContent = activeSwatch ? (activeSwatch.dataset.value || '') : '';
        }
      });

      on(swatch, 'click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');

        if (colorNameEl) colorNameEl.textContent = swatch.dataset.value || '';

        var imgSrc = swatch.dataset.imgSrc;
        if (imgSrc && mainImg) {
          // Build srcset at multiple widths by replacing the width param in the Shopify CDN URL
          function shopifyImageAtWidth(url, w) {
            return url.replace(/(\?|&)(width=)\d+/, '$1$2' + w);
          }
          mainImg.src = shopifyImageAtWidth(imgSrc, 540);
          mainImg.srcset = [
            shopifyImageAtWidth(imgSrc, 400) + ' 400w',
            shopifyImageAtWidth(imgSrc, 540) + ' 540w',
            shopifyImageAtWidth(imgSrc, 720) + ' 720w'
          ].join(', ');
        }

        var variantId = swatch.dataset.variantId;
        if (variantId) {
          card.dataset.variantId = variantId;
          var atcBtn = qs('.js-pcard-atc', card);
          if (atcBtn) atcBtn.dataset.variantId = variantId;
        }
      });
    });
  }

  /* ── Filter form auto-submit ──────────────────────────────── */
  function initFilterForm() {
    var form = qs('#FacetFiltersForm');
    if (!form) return;

    function submitFilters() {
      var params = new URLSearchParams(new FormData(form));
      var clean = new URL(window.location.href);
      clean.search = params.toString() ? ('?' + params.toString()) : '';
      window.location.href = clean.pathname + clean.search;
    }

    // Checkboxes auto-submit
    qsa('input[type="checkbox"]', form).forEach(function (chk) {
      on(chk, 'change', function () {
        var targetUrl = chk.checked ? chk.dataset.urlAdd : chk.dataset.urlRemove;
        if (targetUrl) {
          window.location.href = targetUrl;
          return;
        }
        // Small debounce to allow multiple checkboxes
        clearTimeout(form._submitTimer);
        form._submitTimer = setTimeout(function () { submitFilters(); }, 80);
      });
    });

    // Sort select auto-submit
    var sortSelect = qs('.js-collection-sort', form);
    if (sortSelect) {
      on(sortSelect, 'change', function () { submitFilters(); });
    }

    // Price range: submit on Enter key or blur + clamp values live
    qsa('.facet-price-inputs input', form).forEach(function (inp) {
      on(inp, 'input', function () {
        var val = parseFloat(inp.value);
        var min = parseFloat(inp.min);
        var max = parseFloat(inp.max);
        if (!isNaN(val) && !isNaN(max) && val > max) inp.value = max;
        if (!isNaN(val) && !isNaN(min) && val < min) inp.value = min < 0 ? 0 : '';
      });
      on(inp, 'keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          submitFilters();
        }
      });
      on(inp, 'blur', function () {
        var val = parseFloat(inp.value);
        var min = parseFloat(inp.min);
        var max = parseFloat(inp.max);
        if (!isNaN(val)) {
          if (!isNaN(min) && val < min) inp.value = min;
          if (!isNaN(max) && val > max) inp.value = max;
        }
        clearTimeout(form._priceTimer);
        form._priceTimer = setTimeout(function () { submitFilters(); }, 300);
      });
    });

    on(form, 'submit', function (e) {
      e.preventDefault();
      submitFilters();
    });
  }

  /* ── Active filter removal ────────────────────────────────── */
  function initActiveFilters() {
    qsa('.js-remove-filter').forEach(function (btn) {
      on(btn, 'click', function () {
        var url = new URL(window.location.href);
        url.searchParams.delete(btn.dataset.param);
        if (btn.dataset.value) {
          // Remove only this specific value from a multi-value param
          var vals = url.searchParams.getAll(btn.dataset.param);
          url.searchParams.delete(btn.dataset.param);
          vals.filter(function (v) { return v !== btn.dataset.value; })
              .forEach(function (v) { url.searchParams.append(btn.dataset.param, v); });
        }
        window.location.href = url.toString();
      });
    });
  }

  /* ── Mobile filter drawer ───────────────────────────────────── */
  function initMobileSidebar() {
    var toggles = qsa('.js-filter-toggle, .js-toolbar-filter-toggle');
    var sidebar = qs('.collection-sidebar');
    var overlay = qs('.js-filter-overlay');
    var closeBtn = qs('.js-filter-close');
    if (!sidebar) return;

    function openDrawer() {
      sidebar.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      sidebar.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
      document.body.style.overflow = '';
    }

    toggles.forEach(function (t) { on(t, 'click', openDrawer); });
    if (closeBtn) on(closeBtn, 'click', closeDrawer);
    if (overlay) on(overlay, 'click', closeDrawer);
  }

  /* ── Grid view toggle ───────────────────────────────────────── */
  function initViewToggle() {
    var btns = qsa('.js-view-toggle');
    var grid = qs('#product-grid');
    if (!btns.length || !grid) return;

    btns.forEach(function (btn) {
      on(btn, 'click', function () {
        var cols = btn.dataset.cols;
        grid.style.setProperty('--grid-cols', cols);
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ── Init all cards ───────────────────────────────────────── */
  function initCards() {
    qsa('.js-pcard').forEach(function (card) {
      initSwatches(card);
      initSizes(card);

      // ATC button
      var atcBtn = qs('.js-pcard-atc', card);
      on(atcBtn, 'click', function () {
        var variantId = atcBtn.dataset.variantId || card.dataset.variantId;
        addToCart(variantId, atcBtn);
      });

      // Wishlist button
      var wishBtn = qs('.js-pcard-wishlist', card);
      on(wishBtn, 'click', function () {
        var id = wishBtn.dataset.productId;
        toggleWish(id);
        syncWishButtons();
      });
    });

    syncWishButtons();
  }

  /* ── Custom Sort Dropdown ──────────────────────────────── */
  function initSortDropdown() {
    var toggle = qs('.js-sort-toggle');
    var dropdown = qs('.js-sort-dropdown');
    var hiddenInput = qs('.js-sort-hidden');
    var valueEl = qs('.js-sort-value');
    if (!toggle || !dropdown) return;

    function openDrop() {
      dropdown.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function closeDrop() {
      dropdown.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    on(toggle, 'click', function (e) {
      e.stopPropagation();
      dropdown.classList.contains('is-open') ? closeDrop() : openDrop();
    });

    // Click outside closes
    on(document, 'click', function () { closeDrop(); });
    on(dropdown, 'click', function (e) { e.stopPropagation(); });

    // Option selection
    qsa('.collection-sort__option', dropdown).forEach(function (opt) {
      on(opt, 'click', function () {
        var val = opt.getAttribute('data-value');
        // Update hidden input
        if (hiddenInput) hiddenInput.value = val;
        // Update display
        if (valueEl) valueEl.textContent = opt.textContent.trim();
        // Update active state
        qsa('.collection-sort__option', dropdown).forEach(function (o) {
          o.classList.remove('is-active');
          o.removeAttribute('aria-selected');
        });
        opt.classList.add('is-active');
        opt.setAttribute('aria-selected', 'true');
        closeDrop();

        // Submit the form
        var form = toggle.closest('form');
        if (form) form.submit();
      });
    });
  }

  /* ── Filter by sale (client-side) ──────────────────────── */
  function initSaleFilter() {
    var checkbox = qs('.js-sale-filter');
    if (!checkbox) return;
    on(checkbox, 'change', function () {
      var grid = qs('#product-grid');
      if (!grid) return;
      var cards = qsa('.js-pcard', grid);
      cards.forEach(function (card) {
        var discount = parseInt(card.getAttribute('data-discount') || '0', 10);
        if (checkbox.checked && discount === 0) {
          card.style.display = 'none';
        } else {
          card.style.display = '';
        }
      });
    });
  }

  /* ── Boot ─────────────────────────────────────────────────── */

  /* ── Facet search (filter search boxes) ───────────────────── */
  function initFacetSearch() {
    qsa('.js-facet-search').forEach(function (input) {
      var list = input.closest('.facet-group__body').querySelector('.facet-group__list');
      if (!list) return;
      on(input, 'input', function () {
        var query = input.value.trim().toLowerCase();
        qsa('.facet-group__item', list).forEach(function (li) {
          var text = li.textContent.toLowerCase();
          li.style.display = text.indexOf(query) !== -1 ? '' : 'none';
        });
      });
    });
  }

  /* ── Fallback filters for 5000+ product collections ────── */
  function buildFallbackFilters() {
    var container = qs('.facet-filters');
    if (!container) return;
    // Only build fallback if native filters are empty
    if (container.children.length > 0) return;

    var url = new URL(window.location.href);
    var form = qs('#FacetFiltersForm');

    // ── Availability filter ──
    var availDetail = document.createElement('details');
    availDetail.className = 'facet-group';
    availDetail.setAttribute('open', '');
    var activeAvail = url.searchParams.getAll('filter.v.availability');
    availDetail.innerHTML =
      '<summary class="facet-group__summary">זמינות<span class="facet-group__arrow" aria-hidden="true"><svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></summary>' +
      '<div class="facet-group__body"><ul class="facet-group__list" role="list">' +
      '<li class="facet-group__item"><label class="facet-group__label"><input type="checkbox" name="filter.v.availability" value="1"' + (activeAvail.indexOf('1') !== -1 ? ' checked' : '') + '><span>במלאי</span></label></li>' +
      '<li class="facet-group__item"><label class="facet-group__label"><input type="checkbox" name="filter.v.availability" value="0"' + (activeAvail.indexOf('0') !== -1 ? ' checked' : '') + '><span>אזל מהמלאי</span></label></li>' +
      '</ul></div>';
    container.appendChild(availDetail);

    // ── Price range filter ──
    var priceDetail = document.createElement('details');
    priceDetail.className = 'facet-group';
    priceDetail.setAttribute('open', '');
    var curMin = url.searchParams.get('filter.v.price.gte') || '';
    var curMax = url.searchParams.get('filter.v.price.lte') || '';
    priceDetail.innerHTML =
      '<summary class="facet-group__summary">מחיר<span class="facet-group__arrow" aria-hidden="true"><svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></summary>' +
      '<div class="facet-group__body"><div class="facet-price-range"><div class="facet-price-inputs">' +
      '<input type="number" name="filter.v.price.gte" value="' + curMin + '" placeholder="מ-" min="0" aria-label="מחיר מינימום">' +
      '<span class="facet-price-separator">–</span>' +
      '<input type="number" name="filter.v.price.lte" value="' + curMax + '" placeholder="עד" min="0" aria-label="מחיר מקסימום">' +
      '</div></div></div>';
    container.appendChild(priceDetail);

    // Price submit on Enter / blur + clamp values live
    qsa('.facet-price-inputs input', priceDetail).forEach(function (inp) {
      on(inp, 'input', function () {
        var val = parseFloat(inp.value);
        var min = parseFloat(inp.min);
        var max = parseFloat(inp.max);
        if (!isNaN(val) && !isNaN(max) && val > max) inp.value = max;
        if (!isNaN(val) && !isNaN(min) && val < min) inp.value = min < 0 ? 0 : '';
      });
      on(inp, 'keydown', function (e) { if (e.key === 'Enter' && form) form.submit(); });
      on(inp, 'blur', function () {
        var val = parseFloat(inp.value);
        var min = parseFloat(inp.min);
        var max = parseFloat(inp.max);
        if (!isNaN(val)) {
          if (!isNaN(min) && val < min) inp.value = min;
          if (!isNaN(max) && val > max) inp.value = max;
        }
        clearTimeout(form._priceTimer);
        form._priceTimer = setTimeout(function () { if (form) form.submit(); }, 300);
      });
    });

    // ── Vendor filter (populated via API) ──
    var vendorDetail = document.createElement('details');
    vendorDetail.className = 'facet-group';
    vendorDetail.setAttribute('open', '');
    vendorDetail.innerHTML =
      '<summary class="facet-group__summary">מותג<span class="facet-group__arrow" aria-hidden="true"><svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></summary>' +
      '<div class="facet-group__body">' +
      '<input type="text" class="facet-search-input js-facet-search" placeholder="חיפוש מותג…" autocomplete="off">' +
      '<ul class="facet-group__list facet-group__list--scrollable" role="list"><li class="facet-group__item facet-group__item--loading">טוען…</li></ul></div>';
    container.appendChild(vendorDetail);

    // ── Product type filter (populated via API) ──
    var typeDetail = document.createElement('details');
    typeDetail.className = 'facet-group';
    typeDetail.setAttribute('open', '');
    typeDetail.innerHTML =
      '<summary class="facet-group__summary">סוג מוצר<span class="facet-group__arrow" aria-hidden="true"><svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span></summary>' +
      '<div class="facet-group__body"><ul class="facet-group__list facet-group__list--scrollable" role="list"><li class="facet-group__item facet-group__item--loading">טוען…</li></ul></div>';
    container.appendChild(typeDetail);

    // Auto-submit checkboxes we just added
    qsa('input[type="checkbox"]', container).forEach(function (chk) {
      on(chk, 'change', function () {
        clearTimeout(form._submitTimer);
        form._submitTimer = setTimeout(function () { form.submit(); }, 80);
      });
    });

    // Fetch vendor/type data from products API
    var activeVendors = url.searchParams.getAll('filter.p.vendor');
    var activeTypes = url.searchParams.getAll('filter.p.product_type');
    loadFallbackData(form, activeVendors, activeTypes,
      vendorDetail.querySelector('.facet-group__list'),
      typeDetail.querySelector('.facet-group__list'),
      priceDetail);

    // Wire search boxes
    initFacetSearch();
  }

  function loadFallbackData(form, activeVendors, activeTypes, vendorList, typeList, priceDetail) {
    var handle = window.location.pathname.split('/').filter(Boolean).pop();
    var vendors = {};
    var types = {};
    var minPrice = Infinity;
    var maxPrice = 0;
    var page = 1;
    var maxPages = 8;

    function fetchPage() {
      fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) {
            render();
            return;
          }
          data.products.forEach(function (p) {
            if (p.vendor) vendors[p.vendor] = true;
            if (p.product_type) types[p.product_type] = true;
            // Track price range
            if (p.variants && p.variants.length) {
              p.variants.forEach(function (v) {
                var price = parseFloat(v.price);
                if (!isNaN(price)) {
                  if (price < minPrice) minPrice = price;
                  if (price > maxPrice) maxPrice = price;
                }
              });
            }
          });
          page++;
          if (page <= maxPages && data.products.length === 250) {
            fetchPage();
          } else {
            render();
          }
        })
        .catch(function () { render(); });
    }

    function render() {
      renderFilterList(vendorList, vendors, activeVendors, 'filter.p.vendor', form);
      renderFilterList(typeList, types, activeTypes, 'filter.p.product_type', form);
      // Update price placeholders
      if (priceDetail && maxPrice > 0) {
        var minInput = priceDetail.querySelector('input[name="filter.v.price.gte"]');
        var maxInput = priceDetail.querySelector('input[name="filter.v.price.lte"]');
        if (minInput) { minInput.placeholder = Math.floor(minPrice === Infinity ? 0 : minPrice); minInput.max = Math.ceil(maxPrice); }
        if (maxInput) { maxInput.placeholder = Math.ceil(maxPrice); maxInput.max = Math.ceil(maxPrice); }
      }
      // Re-init facet search after rendering
      initFacetSearch();
    }

    fetchPage();
  }

  function renderFilterList(listEl, valueSet, activeValues, paramName, form) {
    if (!listEl) return;
    var sorted = Object.keys(valueSet).sort(function (a, b) {
      var aActive = activeValues.indexOf(a) !== -1 ? 0 : 1;
      var bActive = activeValues.indexOf(b) !== -1 ? 0 : 1;
      if (aActive !== bActive) return aActive - bActive;
      return a.localeCompare(b);
    });

    listEl.innerHTML = '';
    sorted.forEach(function (val) {
      if (val.toLowerCase().indexOf('gift') !== -1) return;
      var checked = activeValues.indexOf(val) !== -1;
      var li = document.createElement('li');
      li.className = 'facet-group__item';
      li.innerHTML =
        '<label class="facet-group__label"><input type="checkbox" name="' + paramName + '" value="' + val.replace(/"/g, '&quot;') + '"' +
        (checked ? ' checked' : '') + '><span>' + val + '</span></label>';
      listEl.appendChild(li);
      on(li.querySelector('input'), 'change', function () {
        clearTimeout(form._submitTimer);
        form._submitTimer = setTimeout(function () { form.submit(); }, 80);
      });
    });

    if (sorted.length === 0) {
      listEl.innerHTML = '<li class="facet-group__item" style="color:#999;font-size:13px;">לא נמצאו ערכים</li>';
    }
  }

  /* ── Restore native sidebar (Boost PFS override) ──────── */
  function restoreNativeSidebar() {
    var sidebar = qs('#CollectionSidebar');
    if (sidebar) {
      sidebar.style.display = 'block';
      sidebar.style.visibility = 'visible';
      sidebar.style.opacity = '1';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCards();
    initFilterForm();
    initSortDropdown();
    initFacetSearch();
    initActiveFilters();
    initMobileSidebar();
    initViewToggle();
    initSaleFilter();
    buildFallbackFilters();

    // Restore sidebar in case Boost hides it
    setTimeout(restoreNativeSidebar, 800);
    setTimeout(restoreNativeSidebar, 2000);
    setTimeout(restoreNativeSidebar, 4000);
  });

})();
